import { render, staticRenderFns } from "./pastClaimsList.vue?vue&type=template&id=71f76ef8&"
import script from "./pastClaimsList.vue?vue&type=script&lang=js&"
export * from "./pastClaimsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports